import { render } from "./New.vue?vue&type=template&id=06e27b54&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=06e27b54&scoped=true&lang=css"
import "@vueform/toggle/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/var/www/ambientaly/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e27b54"]])

export default __exports__